import { css } from 'styled-components';

const styles = css`
  .Modal-Header {
    top: 0;
    position: sticky;
    z-index: 100;
    min-height: 53px;
  }
  .close-modal {
    margin-top: 5px;
  }
  .modal-heading {
    display: flex !important;
    border-bottom: none;
    padding-bottom: 26px;
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    justify-content: center;
    height: auto;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0 30px 0 20px;
    white-space: nowrap;
    @media ${(props) => props.theme.mediaQuery.medium} {
      height: auto;
      padding-top: 16px;
      justify-content: center;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs16} !important;
      padding-top: 9px;
      text-align: center;
      justify-content: center;
    }
  }

  div.TCPModal__InnerContent.atb-innerContent.cart-offers-modal {
    padding: 10px 10px 0px 0px;
    padding: 0px !important;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: auto;
      max-height: 90vh;
      overflow-y: auto;
      top: auto;
      bottom: 0;
    }
  }
  div.TCPModal__InnerContent.atb-innerContent .modal-heading {
    padding: 10px 10px 0px 0px !important;
    display: flex !important;
    justify-content: center !important;
  }

  .modal-heading:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 51px;
    margin: auto;
    z-index: -1;
    background-color: ${(props) => props.theme.colors.CULTURED};
    bottom: 10px;
    left: -17px;
    padding-right: 17px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding-right: 17px;
    }
  }
  .modal-content {
    padding: 8px 15px;
    padding-bottom: 53px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: 24px;
    }
  }
  .product-container {
    display: flex;
    margin-bottom: 16px;
    width: 100%;
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-bottom: 24px;
    }
  }
  .product-details {
    margin-left: 14px;
    width: 100%;
  }
  .price-drop-product-image {
    width: 62px;
    height: 62px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 90px;
      height: 90px;
    }
  }

  .product-category {
    color: #595959;
  }
  .product-details-section {
    display: flex;
    flex-direction: column;
  }
  .product-name-price {
    justify-content: space-between;
    display: flex;
    line-height: 150%;
    padding-top: 5px;
    width: 100%;
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding-top: 10px;
    }
  }
  .product-price {
    color: #c8102e;
    margin-left: 6px;
  }
  .price-drop-container {
    display: flex;
  }
  .price-drop-icon {
    width: 14px;
    height: 14px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 16px;
      height: 16px;
    }
  }
`;

export default styles;
